import { Box, Tooltip, TooltipProps } from '@mui/material';
import { ReactElement } from 'react';

interface IWithTooltip {
  tooltip?: TooltipProps['title'];
  children: ReactElement;
  placement?: TooltipProps['placement'];
}

export const WithTooltip = ({
  tooltip,
  children,
  placement = 'top',
}: IWithTooltip) => {
  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement={placement}>
        <Box>{children}</Box>
      </Tooltip>
    );
  }

  return children;
};
